export const LABELS = {
  RegistrationAddress: 'Адрес регистрации',
  ChangePhoneNumber: 'Изменить номер',
  RegionLabel: 'В каком городе будете получать кредит',
  AdditionalPhoneLabel: 'Дополнительный телефон',
  PropertyAvailabilityLabel: 'Наличие имущества',
};

export const PRODUCT_CATEGORIES_LABELS = {
  CreditCard: 'Кредитная карта',
  Credit: 'Кредит',
  MicroCredit: 'Микрозаймы',
  AutoCredit: 'Автокредит',
  Mortgage: 'Ипотека',
};
